<div class="information-dialog" [ngClass]="data.dialogClass">
    <ng-container *ngIf="data.imageAboveHeader; else imageUnderHeader">
        <img *ngIf="data.imageSrc" class="information-dialog__image"
             [src]="data.imageSrc"
             alt="">
        <h2 class="information-dialog__header">{{data.header | translate}}</h2>
    </ng-container>
    <ng-template #imageUnderHeader>
        <h2 class="information-dialog__header">{{data.header | translate}}</h2>
        <img *ngIf="data.imageSrc" class="information-dialog__image"
             [src]="data.imageSrc"
             alt="">
    </ng-template>
    <p class="information-dialog__paragraph" [innerHTML]="data.mainText | translate | safeHtml"></p>
    <p class="information-dialog__paragraph">{{data.additionalText | translate}}</p>
    <p class="information-dialog__paragraph">{{data.footer | translate}}</p>
    <button *ngIf="buttonVisible" [mat-dialog-close]="data.actionKey" class="information-dialog__button btn btn--secondary btn--big">
        {{data.actionText | translate}}
    </button>
</div>
